// Skin Theory: 150 statt 300 ms. Genutzt nur von cart.js und quick-add-bulk.js;
// fasst schnelle Doppel-Tipps weiter zusammen, fühlt sich aber direkter an.
const ON_CHANGE_DEBOUNCE_TIMER = 150;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
